import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "space-y-3 rounded-md pb-3" }
const _hoisted_3 = {
  key: 5,
  class: "flex flex-col gap-2"
}
const _hoisted_4 = { class: "max-w-max" }

import type { PageSection } from "@/apps/page/page.interfaces";
import {
    BlockDefinition,
    BlockDefinitionGroup,
    BlockTypeGroup,
} from "@/apps/page/services/blocks/block.interfaces";
import { BlockBaseElement, BlockDataValue, BlockMedia } from "@/views/blocks/PageBlock.interface";
import { ButtonTertiaryIconXs } from "@easy/ui/buttons";
import { CardToggle, CardToggleAlt } from "@easy/ui/cards";
import {
    FormInput,
    FormInputQuantity,
    FormLabel,
    FormRichText,
    FormSelect,
    FormTextArea,
} from "@easy/ui/forms";
import { InvisibleIcon, VisibleIcon } from "@easy/ui/icons";
import BlockImage from "../BlockImage.vue";
import GroupItems from "../GroupItems.vue";
import GroupMedia from "./GroupMedia.vue";
import LinkField from "./LinkField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlockFieldGroups',
  props: {
    groupTypes: {},
    groupedDataFields: {},
    section: {},
    showVisibilityToggle: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupTypes, (groupType) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: groupType.group
    }, [
      (_ctx.groupedDataFields[groupType.group]?.length > 0)
        ? (_openBlock(), _createBlock(_unref(CardToggle), {
            key: 0,
            title: groupType.name
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedDataFields[groupType.group], (groupedField) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: groupedField.value
                  }, [
                    (groupedField.groupType === 'multiple')
                      ? (_openBlock(), _createBlock(GroupItems, {
                          key: 0,
                          "grouped-field": groupedField,
                          section: _ctx.section,
                          "group-icon": groupType.icon
                        }, null, 8, ["grouped-field", "section", "group-icon"]))
                      : _createCommentVNode("", true),
                    (groupedField.groupType === 'single')
                      ? (_openBlock(), _createBlock(_unref(CardToggleAlt), {
                          key: 1,
                          "data-field": groupedField.value,
                          title: groupedField.label,
                          icon: groupType.icon,
                          class: _normalizeClass({
                                'opacity-50': _ctx.section.dataValues[groupedField.value].isHidden,
                            })
                        }, _createSlots({
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                              (groupedField.group === 'media')
                                ? (_openBlock(), _createBlock(GroupMedia, {
                                    key: 0,
                                    fields: groupedField.fields,
                                    "group-data": 
                                            _ctx.section.dataValues[groupedField.value]
                                                .data as BlockMedia
                                        
                                  }, null, 8, ["fields", "group-data"]))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(groupedField.fields, (field) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: field.value
                                    }, [
                                      (field.type === 'text')
                                        ? (_openBlock(), _createBlock(_unref(FormInput), {
                                            key: 0,
                                            id: field.value,
                                            title: field.label,
                                            modelValue: 
                                                _ctx.section.dataValues[groupedField.value].data[
                                                    field.value as keyof BlockDataValue
                                                ]
                                            ,
                                            "onUpdate:modelValue": ($event: any) => ((
                                                _ctx.section.dataValues[groupedField.value].data[
                                                    field.value as keyof BlockDataValue
                                                ]
                                            ) = $event)
                                          }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true),
                                      (field.type === 'textarea')
                                        ? (_openBlock(), _createBlock(_unref(FormTextArea), {
                                            key: 1,
                                            id: field.value,
                                            title: field.label,
                                            modelValue: 
                                                _ctx.section.dataValues[groupedField.value].data[
                                                    field.value as keyof BlockDataValue
                                                ]
                                            ,
                                            "onUpdate:modelValue": ($event: any) => ((
                                                _ctx.section.dataValues[groupedField.value].data[
                                                    field.value as keyof BlockDataValue
                                                ]
                                            ) = $event),
                                            rows: field.rows
                                          }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue", "rows"]))
                                        : _createCommentVNode("", true),
                                      (field.type === 'select')
                                        ? (_openBlock(), _createBlock(_unref(FormSelect), {
                                            key: 2,
                                            modelValue: 
                                                _ctx.section.dataValues[groupedField.value].data[
                                                    field.value as keyof BlockDataValue
                                                ]
                                            ,
                                            "onUpdate:modelValue": ($event: any) => ((
                                                _ctx.section.dataValues[groupedField.value].data[
                                                    field.value as keyof BlockDataValue
                                                ]
                                            ) = $event),
                                            label: field.label,
                                            options: field.options,
                                            value: 
                                                _ctx.section.dataValues[groupedField.value].data[
                                                    field.value as keyof BlockDataValue
                                                ]
                                            
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "options", "value"]))
                                        : _createCommentVNode("", true),
                                      (field.type === 'html')
                                        ? (_openBlock(), _createBlock(_unref(FormRichText), {
                                            key: 3,
                                            id: field.value,
                                            title: field.label,
                                            modelValue: 
                                                _ctx.section.dataValues[groupedField.value].data[
                                                    field.value as keyof BlockDataValue
                                                ]
                                            ,
                                            "onUpdate:modelValue": ($event: any) => ((
                                                _ctx.section.dataValues[groupedField.value].data[
                                                    field.value as keyof BlockDataValue
                                                ]
                                            ) = $event),
                                            rows: field.rows
                                          }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue", "rows"]))
                                        : _createCommentVNode("", true),
                                      (field.type === 'image')
                                        ? (_openBlock(), _createBlock(BlockImage, {
                                            key: 4,
                                            id: field.value,
                                            title: field.label,
                                            modelValue: 
                                                _ctx.section.dataValues[groupedField.value].data[
                                                    field.value as keyof BlockDataValue
                                                ]
                                            ,
                                            "onUpdate:modelValue": ($event: any) => ((
                                                _ctx.section.dataValues[groupedField.value].data[
                                                    field.value as keyof BlockDataValue
                                                ]
                                            ) = $event)
                                          }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true),
                                      (field.type === 'slider')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            _createVNode(_unref(FormLabel), null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(field.label), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createElementVNode("div", _hoisted_4, [
                                              _createVNode(_unref(FormInputQuantity), {
                                                title: field.label,
                                                modelValue: 
                                                        _ctx.section.dataValues[groupedField.value].data[
                                                            field.value as keyof BlockDataValue
                                                        ]
                                                    ,
                                                "onUpdate:modelValue": ($event: any) => ((
                                                        _ctx.section.dataValues[groupedField.value].data[
                                                            field.value as keyof BlockDataValue
                                                        ]
                                                    ) = $event)
                                              }, null, 8, ["title", "modelValue", "onUpdate:modelValue"])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (field.type === 'link')
                                        ? (_openBlock(), _createBlock(LinkField, {
                                            key: 6,
                                            field: field,
                                            item: _ctx.section.dataValues[groupedField.value].data
                                          }, null, 8, ["field", "item"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                            ])
                          ]),
                          _: 2
                        }, [
                          (_ctx.showVisibilityToggle)
                            ? {
                                name: "actions",
                                fn: _withCtx(() => [
                                  _createVNode(_unref(ButtonTertiaryIconXs), {
                                    onClick: ($event: any) => (
                                        _ctx.section.dataValues[groupedField.value].isHidden =
                                            !_ctx.section.dataValues[groupedField.value].isHidden
                                    )
                                  }, {
                                    default: _withCtx(() => [
                                      (!_ctx.section.dataValues[groupedField.value].isHidden)
                                        ? (_openBlock(), _createBlock(_unref(VisibleIcon), { key: 0 }))
                                        : (_openBlock(), _createBlock(_unref(InvisibleIcon), { key: 1 }))
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1032, ["data-field", "title", "icon", "class"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["title"]))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}
}

})